"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfNewsFeedsClient = void 0;
const fetch_1 = require("./fetch");
class VcfNewsFeedsClient {
    constructor(authService, stage) {
        this.authService = authService;
        this.stage = stage;
        this.headers = {
            'User-Id': '__userId__',
            'Content-Type': 'application/json',
        };
        this.getGdcType = (isWcar) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;
        this.resourceHostId = `myvw-vcf-${stage}`;
    }
    ;
    async getNewsFeeds(vin, isWcar) {
        const url = `vehicles/${vin}/newsfeeds?gdc=${this.getGdcType(isWcar)}`;
        return (0, fetch_1.getRequest)(this.authService, this.resourceHostId, url, this.headers);
    }
    ;
    async deleteNewsFeed(vin, id, isWcar) {
        const url = `vehicles/${vin}/newsfeeds/${id}?gdc=${this.getGdcType(isWcar)}`;
        return (0, fetch_1.deleteRequest)(this.authService, this.resourceHostId, url, this.headers);
    }
    ;
    async postNewsfeeds(vin, feedUrl, isWcar) {
        const url = `vehicles/${vin}/newsfeeds?gdc=${this.getGdcType(isWcar)}`;
        return (0, fetch_1.postRequest)(this.authService, this.resourceHostId, url, feedUrl, this.headers);
    }
    ;
}
exports.VcfNewsFeedsClient = VcfNewsFeedsClient;
//# sourceMappingURL=VcfNewsFeedsClient.js.map